module.exports = __webpack_public_path__ + "img/ARS_1489.7d6ac461.jpg";